export default {
  login: "bradtraversy",
  id: 5550850,
  node_id: "MDQ6VXNlcjU1NTA4NTA=",
  avatar_url: "https://avatars.githubusercontent.com/u/5550850?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/bradtraversy",
  html_url: "https://github.com/bradtraversy",
  followers_url: "https://api.github.com/users/bradtraversy/followers",
  following_url:
    "https://api.github.com/users/bradtraversy/following{/other_user}",
  gists_url: "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/bradtraversy/subscriptions",
  organizations_url: "https://api.github.com/users/bradtraversy/orgs",
  repos_url: "https://api.github.com/users/bradtraversy/repos",
  events_url: "https://api.github.com/users/bradtraversy/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/bradtraversy/received_events",
  type: "User",
  site_admin: false,
  name: "Brad Traversy",
  company: "Traversy Media",
  blog: "traversymedia.com",
  location: "Boston",
  email: null,
  hireable: true,
  bio:
    "Full stack web developer and online instructor, specializiing in mostly JS, but also write Python, PHP and some other stuff.",
  twitter_username: null,
  public_repos: 214,
  public_gists: 37,
  followers: 38200,
  following: 6,
  created_at: "2013-09-26T15:36:02Z",
  updated_at: "2021-04-13T14:14:34Z",
};
